import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { CommandContribution } from '@patsnap/tahiti-core';
import { FtoSearchApi, FtoSearchApiImpl } from './apis';
import { LanguageApi, LanguageApiImpl } from './apis';
import { FtoCommandContribution } from './services/fto-command-contribution';

export const ftoSearchContainer = new ContainerModule((bind) => {
    bind(FtoSearchApi).to(FtoSearchApiImpl);
    bind(LanguageApi).to(LanguageApiImpl);
    bind(CommandContribution).to(FtoCommandContribution);
});
